var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 40.0012C31.0467 40.0012 40.001 31.0469 40.001 20.0012C40.001 8.95553 31.0467 0.0012207 20.001 0.0012207C8.95528 0.0012207 0.000976562 8.95553 0.000976562 20.0012C0.000976562 31.0469 8.95528 40.0012 20.001 40.0012Z",
    fill: "url(#paint0_radial_1032_338022)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint1_linear_1032_338022)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.001 20C40.001 8.9543 31.0467 -1.35705e-06 20.001 -8.74228e-07C8.95528 -3.91405e-07 0.000975205 8.95431 0.000975688 20C0.000976171 31.0457 8.95528 40 20.001 40C31.0467 40 40.001 31.0457 40.001 20Z",
    fill: "url(#paint2_radial_1032_338022)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_338022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4166 17.1667H13.5833C12.854 17.1667 12.1545 17.4565 11.6388 17.9722C11.123 18.4879 10.8333 19.1874 10.8333 19.9167V27.2501C10.8333 27.9794 11.123 28.6789 11.6388 29.1946C12.1545 29.7104 12.854 30.0001 13.5833 30.0001H26.4166C27.146 30.0001 27.8455 29.7104 28.3612 29.1946C28.8769 28.6789 29.1666 27.9794 29.1666 27.2501V19.9167C29.1666 19.1874 28.8769 18.4879 28.3612 17.9722C27.8455 17.4565 27.146 17.1667 26.4166 17.1667ZM20 25.4167C19.6374 25.4167 19.2829 25.3092 18.9814 25.1078C18.6799 24.9063 18.445 24.62 18.3062 24.285C18.1674 23.95 18.1311 23.5814 18.2019 23.2257C18.2726 22.8701 18.4472 22.5434 18.7036 22.2871C18.96 22.0307 19.2867 21.856 19.6423 21.7853C19.9979 21.7146 20.3666 21.7509 20.7016 21.8896C21.0366 22.0284 21.3229 22.2634 21.5243 22.5649C21.7258 22.8664 21.8333 23.2208 21.8333 23.5834C21.8333 24.0696 21.6402 24.536 21.2963 24.8798C20.9525 25.2236 20.4862 25.4167 20 25.4167Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.3333H23.6667V13.5C23.6769 12.5385 23.3051 11.6123 22.6329 10.9248C21.9607 10.2373 21.0431 9.84471 20.0816 9.83334H20.0431C19.564 9.82497 19.0881 9.91107 18.6423 10.0867C18.1966 10.2624 17.7898 10.5242 17.4453 10.8571C17.1008 11.1901 16.8252 11.5877 16.6344 12.0271C16.4436 12.4666 16.3413 12.9394 16.3333 13.4184V15.3333H14.5V13.4083C14.5147 11.9707 15.0954 10.5969 16.1162 9.5845C17.1369 8.57212 18.5156 8.00283 19.9533 8.00001H20.0092C20.7322 7.99867 21.4483 8.14039 22.1162 8.417C22.7842 8.69362 23.3909 9.09966 23.9013 9.61174C24.4116 10.1238 24.8156 10.7318 25.09 11.4007C25.3644 12.0696 25.5037 12.7862 25.5 13.5092V15.3333Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1032_338022)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50002 30C16.4787 30 27 19.4787 27 6.50003C27 4.6177 26.7787 2.78706 26.3607 1.03271C34.2881 3.69003 40 11.178 40 20C40 31.0457 31.0457 40 20 40C12.5912 40 6.12333 35.9715 2.6673 29.9856C2.94368 29.9952 3.22129 30 3.50002 30Z",
    fill: "url(#paint3_linear_1032_338022)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1032_338022",
    x: 1.33396,
    y: -0.300619,
    width: 39.9994,
    height: 41.634,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1032_338022"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1032_338022",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1032_338022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9271 -0.000144778) rotate(135) scale(34.9872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1032_338022",
    x1: 18.3343,
    y1: -3.33334,
    x2: 0.000973962,
    y2: 23.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1032_338022",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26 9.5) rotate(143.291) scale(47.3994 39.1256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1032_338022",
    x1: 21.3388,
    y1: 40,
    x2: 26.3303,
    y2: 11.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_338022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9 8)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.e4930c1b.svg";
export { ForwardRef as ReactComponent };